import {customElement} from "lit/decorators.js";
import {TabModel} from "../../common/tabModel";
import {UnLitElement} from "../../common/elements";
import {KEYS} from "../../common/utils/events";
import {ClickTracking} from "../../tracking/clickTracking";
import {resolve} from "../../container";


@customElement("eop-binary-content-switch")
export class EopBinaryContentSwitch extends UnLitElement {
    private labels: TabModel;
    private contents: TabModel;
    private switchButton: HTMLElement;
    private toggled: boolean = false;

    public constructor(private clickTracking: ClickTracking = resolve(ClickTracking)) {
        super();

        this.labels = new TabModel(this, this.querySelectorAll(".binary-switch-label")).periodicSwitch({class: "active"});
        this.contents = new TabModel(this, this.querySelectorAll(".binary-switch-content")).periodicSwitch({class: "active"});
        this.switchButton = this.querySelector<HTMLElement>(".binary-switch-button")!;
    }

    public connectedCallback(): void {
        super.connectedCallback();

        this.updateAttributes();

        this.switchButton.addEventListener("click", (event: PointerEvent) => this.toggle(event));
        this.switchButton.addEventListener("keydown", (event: KeyboardEvent) => {
            if (event.key === KEYS.ENTER || event.key === KEYS.SPACE || event.key === KEYS.ARROW_LEFT || event.key === KEYS.ARROW_RIGHT) {
                event.preventDefault();
                this.toggle(event);
            }
        });
    }

    private toggle(event: Event): void {
        event.stopPropagation();
        this.clickTracking.handleButtonInteract(event, "binary-switch-toggle");

        this.toggled = !this.toggled;
        this.updateAttributes();
        this.labels.selectNext();
        this.contents.selectNext();
    }

    private updateAttributes(): void {
        if (this.toggled) {
            this.switchButton.classList.add("toggled");
        } else {
            this.switchButton.classList.remove("toggled");
        }
        this.switchButton.setAttribute("aria-checked", this.toggled.toString());
    }
}